module.exports = __webpack_public_path__ + "937505f2c250930fde693906a8e930c5.svg";